import { Heading } from "@chakra-ui/react";
import { ResidenceTypesWithoutImageModal } from "../components/modals/ResidenceTypesWithoutImageModal";

export function HomePage() {
  return <>
    <ResidenceTypesWithoutImageModal />
    <Heading>Je bent ingelogd!</Heading>
  </>
}